export const createFormData = (file: File): FormData => {
  const uploadFormData = new FormData();
  uploadFormData.append('file', file, file.name);
  return uploadFormData;
};
